<script>
export default {
  computed: {
    isTouchDevice() {
      var result = false;
      if (window.ontouchstart === null) {
        result = true;
      }
      return result;
    }
  }
};
</script>
